// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBkA4V5CLdexdkQyj4a2YkwjvQpsOvTY2Q",
  authDomain: "jandj-516e0.firebaseapp.com",
  projectId: "jandj-516e0",
  storageBucket: "jandj-516e0.firebasestorage.app",
  messagingSenderId: "993226449541",
  appId: "1:993226449541:web:8590722b73f1a66843ffec",
  measurementId: "G-1XFNEZFYCN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, db };